/* components/invite/endpage.tsx */ 

import React from 'react';

interface Props { status: 'accepted' | 'declined'; }

const EndPage: React.FC<Props> = ({ status }) => (
  <div className="h-screen flex flex-col items-center justify-center bg-black text-white">
    {status === 'accepted' ? (
      <>
        <div className="text-5xl mb-4">🎉</div>
        <h1 className="text-3xl font-black">See you there!</h1>
      </>
    ) : (
      <>
        <div className="text-5xl mb-4">🙂</div>
        <h1 className="text-3xl font-black">Maybe next time!</h1>
      </>
    )}
  </div>
);

export default EndPage;
